module.exports = __webpack_public_path__ + "img/MARCA_OCATECH.95a28c25.png";